import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import toolsIcon from "../assets/portfolio/coming-soon.png";
import spendIcon from "../assets/product-icons/spendnote.png";
import shreeIcon from "../assets/portfolio/Group.svg";
import scoraIcon from "../assets/product-icons/scora.png";
import empireIcon from "../assets/portfolio/coming-soon.png";

const works = [
  {
    id: "scora",
    title: "Scora",
    type: "Knowledge product",
    desc: "A document search and knowledge experience designed for fast retrieval, clean reading, and practical daily use.",
    icon: scoraIcon,
    link: "/products/scora",
  },
  {
    id: "spendnote",
    title: "SpendNote",
    type: "Finance app",
    desc: "A consumer expense-tracking product with quick capture, simple navigation, and a focused mobile interface.",
    icon: spendIcon,
    link: "/products/spendnote",
  },
  {
    id: "shree",
    title: "Shree Electronics",
    type: "Business website",
    desc: "A polished digital presence for an electronics business, built to make offerings easier to browse and trust.",
    icon: shreeIcon,
    link: "/portfolio/shree",
  },
  {
    id: "empire",
    title: "Empire HiTech",
    type: "Business platform",
    desc: "A modern business interface direction for presenting services, operations, and company credibility.",
    icon: empireIcon,
    link: "/portfolio/empire",
  },
  {
    id: "tools",
    title: "Code7s Studio Tools",
    type: "Tool suite",
    desc: "Internal and public tools shaped for indie builders, freelancers, and fast-moving studio workflows.",
    icon: toolsIcon,
    link: "/products/tools",
  },
];

export default function Portfolio() {
  const navigate = useNavigate();

  return (
    <main className="premium-page">
      <section className="premium-shell">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="page-hero-block"
        >
          <p className="eyebrow">Selected work</p>
          <h1 className="hero-heading mt-5">
            Product work with launch energy.
          </h1>
          <p className="hero-copy">
            Explore Code7s work across startup MVPs, mobile apps, ecommerce
            websites, SaaS interfaces, business dashboards, product design
            systems and Code7s published apps.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {works.map((work, index) => (
            <motion.button
              key={work.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
              onClick={() => navigate(work.link)}
              className="premium-card group rounded-[26px] p-6 text-center"
            >
              <div className="flex flex-col items-center gap-5">
                <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-3xl bg-neutral-950/5">
                  <img src={work.icon} alt="" className="h-12 w-12 object-contain" />
                </div>
                <div className="text-center">
                  <span className="rounded-full border border-neutral-950/10 bg-white/70 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-neutral-500">
                    {work.type}
                  </span>
                  <h2 className="mt-5 text-3xl font-extrabold tracking-tight">{work.title}</h2>
                </div>
              </div>
              <p className="mx-auto mt-5 max-w-xl leading-7 text-neutral-600">{work.desc}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm font-bold">
                View case <FiArrowUpRight aria-hidden="true" />
              </span>
            </motion.button>
          ))}
        </div>
      </section>
    </main>
  );
}
